import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const PaymentSuccessIcon = React.memo(
  ({ width = 100, fill = variables['colors-mc-primary'] }) => (
      <svg width={remCss(width)} height={remCss(width)} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="100" height="100" rx="50" fill={fill} fillOpacity="0.1"/>
        <circle cx="50" cy="50" r="25" fill={fill}/>
        <g clipPath="url(#clip0_811_10428)">
          <path d="M46.6846 56.1248L40.793 49.9998L38.8291 52.0415L46.6846 60.2082L63.5178 42.7082L61.554 40.6665L46.6846 56.1248Z" fill="white"/>
        </g>
        <defs>
          <clipPath id="clip0_811_10428">
            <rect width="33.6665" height="35" fill="white" transform="translate(34.0596 32.5)"/>
          </clipPath>
        </defs>
      </svg>

  )
);
PaymentSuccessIcon.displayName = 'PaymentSuccessIcon';

export default PaymentSuccessIcon;
